// extracted by mini-css-extract-plugin
export var center = "footer-module--center--bc0b0";
export var container = "footer-module--container--e4696";
export var footer = "footer-module--footer--675c6";
export var heycoddes = "footer-module--heycoddes--b065f";
export var left = "footer-module--left--906e9";
export var link = "footer-module--link--b9172";
export var logo = "footer-module--logo--62df3";
export var right = "footer-module--right--a9b79";